import { RevenueDownloadContent } from '@e2m-customer-portal/domains';
import { Drawer, DrawerContent, DrawerFooter, DrawerHeader } from '@e2m-customer-portal/ui';
import { Typography } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface RevenueDownloadDrawerProps {
  open: boolean;
  onClose: () => void;
  marketLocationId: string;
}

export function RevenueDownloadDrawer({
  open,
  onClose,
  marketLocationId,
}: Readonly<RevenueDownloadDrawerProps>): ReactElement<RevenueDownloadDrawerProps> {
  const [t] = useTranslation();

  return (
    <Drawer open={open} onClose={onClose}>
      <DrawerHeader cancelLabel={t('SHARED_CANCEL')}>
        <Typography variant="h3">{t('REVENUE_DOWNLOAD_DRAWER_TITLE')}</Typography>
      </DrawerHeader>

      <DrawerContent unknownErrorLabel={t('SHARED_ERROR_UNKNOWN')}>
        <RevenueDownloadContent marketLocationId={marketLocationId} />
      </DrawerContent>

      <DrawerFooter noDivider>
        <Typography variant="body2">{t('REVENUE_DOWNLOAD_DISCLAIMER')}</Typography>
      </DrawerFooter>
    </Drawer>
  );
}
